export default () => {
  let targets = document.querySelectorAll('.header');

  if (targets.length) {
    targets.forEach((header) => {
      let nav = header.querySelector('.header__nav');

      header.querySelector('.header__open').addEventListener('click', () => {
        nav.classList.remove('fade-off');
      });
      header.querySelector('.header__close').addEventListener('click', () => {
        nav.classList.add('fade-off');
      });
    });
  }
}